import ClosureSurveyData from 'sprockets_react/closure_survey/data/registry'

ClosureSurveyData.Actions = {
  dispatcher: function() {
    return ClosureSurveyData.Dispatcher;
  },
  resetData: function() {
    this.dispatcher().dispatch({
      type: 'data:closure_survey:reset'
    })
  }
}
